export const load = storageKey => JSON.parse(window.localStorage.getItem(storageKey));
